// extracted by mini-css-extract-plugin
export default {"missing-fonts-headline":"styles_missing-fonts-headline__LXUE7"};